import React from 'react';
import { useBackButtonState } from 'src/shef-global-state/backButtonState';
import styled from 'styled-components';
import {
  CallToActionButton,
  Content,
  ContentBody,
  Header,
  LeftCornerImg,
  RightCornerImg,
  SubHeader,
} from './content-styles';

const ModalHeader = styled(Header)`
  font-size: 28px;
  line-height: 34px;
`;

export const AlreadyOrdered: React.FC<{ shefName: string }> = ({ shefName }) => {
  const { goBack } = useBackButtonState();

  return (
    <Content>
      <LeftCornerImg />
      <RightCornerImg />
      <SubHeader>Learn About</SubHeader>
      <ModalHeader>Taste Testing</ModalHeader>
      <ContentBody>
        <p>Thank you for ordering from Shef {shefName}.</p>
        <p>You can only order from each Trial shef one time.</p>
      </ContentBody>
      <CallToActionButton onClick={goBack}>Explore Other Shefs</CallToActionButton>
    </Content>
  );
};
